import { render, staticRenderFns } from "./JXSList.vue?vue&type=template&id=e2c0cccc&scoped=true&"
import script from "./JXSList.vue?vue&type=script&lang=js&"
export * from "./JXSList.vue?vue&type=script&lang=js&"
import style0 from "./JXSList.vue?vue&type=style&index=0&id=e2c0cccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c0cccc",
  null
  
)

export default component.exports